// Blueprint: forge/blueprint/frontend/architecture/001-shell-composition.md
import { Configuration, ModulesApi, NavSectionsApi, UserApi } from 'org-hub-api';

/** Header forwarded to BFF/API for org-scoped permission filtering and canary routing. */
export const RootOrgIdHeader = 'X-Root-Org-Id';

/** Default same-origin proxy prefix for embedded hosts (ST.Core / EH-style). Standalone uses `''`. */
export const DEFAULT_EMBEDDED_API_BASE_URL = '/bffproxy/org-hub';

export function createApiConfiguration(
    rootOrgId?: string | null,
    apiBaseUrl: string = ''
): Configuration {
    const headers: Record<string, string> = {};
    if (rootOrgId) {
        headers[RootOrgIdHeader] = rootOrgId;
    }
    return new Configuration({
        basePath: apiBaseUrl,
        baseOptions: { withCredentials: true, headers },
    });
}

/**
 * The caller's root org from `/api/me`, for hosts that can't pass one. Read failures propagate; a
 * 2xx body that isn't the user DTO (e.g. a host's HTML fallback page) resolves to `null`.
 */
export async function fetchRootOrgId(apiBaseUrl: string): Promise<string | null> {
    const { data } = await new UserApi(createApiConfiguration(null, apiBaseUrl)).getUserInfo();
    return data.rootOrgId ?? null;
}

/** Shared Configuration + generated clients as react-ioc value providers. */
export function createApiProviders(rootOrgId?: string | null, apiBaseUrl: string = '') {
    const configuration = createApiConfiguration(rootOrgId, apiBaseUrl);
    return [
        { provide: Configuration, useValue: configuration },
        { provide: UserApi, useValue: new UserApi(configuration) },
        { provide: NavSectionsApi, useValue: new NavSectionsApi(configuration) },
        { provide: ModulesApi, useValue: new ModulesApi(configuration) },
    ];
}
